import api from "api";
import { supportApiBase } from "api/constants";
import { useMutation, useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";

const useResendTherapistInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (therapistId: number) =>
      api.call(`/therapists/${therapistId}/resend_invitation`, {
        method: "POST",
        root: supportApiBase,
      }),
    {
      onSuccess: (_, therapistId) => {
        queryClient.invalidateQueries(queryKeys.therapist(therapistId));
      },
    }
  );
};

export default useResendTherapistInvitation;
